<script setup lang="ts">
import { computed } from 'vue';
import { AppContext } from '@/models/AppContext';
import { useAuthStore } from '@/shared/stores/authStore';
import { isCognitoEnabled, isNativeCognitoEnabled } from '@/shared/auth/cognitoFeatureFlag';
import { useIsLoggedIn } from '@/shared/auth/useIsLoggedIn';
import AuthError from '@/shared/components/Auth/AuthError.vue';

const props = withDefaults(
  defineProps<{
    appContext?: AppContext;
  }>(),
  {
    appContext: AppContext.SolCentre,
  },
);

const authStore = useAuthStore();
const loggedIn = useIsLoggedIn(props.appContext);
const nativeBlocked = computed(() => isNativeCognitoEnabled && !authStore.isProfileHydrated);

const showHydrationSpinner = computed(
  () =>
    isCognitoEnabled &&
    loggedIn.value &&
    authStore.lifecycleStatus.profileHydrationStatus === 'loading',
);

const showHydrationError = computed(
  () =>
    isCognitoEnabled &&
    loggedIn.value &&
    authStore.lifecycleStatus.profileHydrationStatus === 'error',
);
</script>

<template>
  <AuthError v-if="showHydrationError" />
  <a-spin v-else-if="showHydrationSpinner" :spinning="true" class="auth-profile-hydration-spin">
    <slot v-if="!nativeBlocked" />
  </a-spin>
  <slot v-else-if="!nativeBlocked" />
</template>

<style scoped>
.auth-profile-hydration-spin {
  display: block;
  min-height: 200px;
}
</style>
